import { Grid2, Show, Tab, Tabs } from "components";
import { lazy, useState } from "react";
import useDocumentTitle from "utils/useDocumentTitle";

const PortfolioAccess = lazy(() => import("./PortfolioAccess"));
const PortfolioFamilyAccess = lazy(() => import("./PortfolioFamilyAccess"));

const PortfolioSettingsEdit = () => {
  useDocumentTitle("Portfolio Access");

  const [portfolioTabs, setPortfolioTabs] = useState(0);

  const tabs = [
    { label: "Admin Access", component: PortfolioAccess },
    { label: "Family Access", component: PortfolioFamilyAccess },
  ];

  return (
    <>
      <Grid2 container spacing={1}>
        <Grid2 size={3} display={"flex"} alignItems={"center"}>
          <Tabs
            value={portfolioTabs}
            variant="standard"
            className="light"
            onChange={(e, val) => {
              setPortfolioTabs(val);
            }}
            TabIndicatorProps={{
              style: {
                display: "none",
              },
            }}
          >
            {tabs.map((tab, index) => (
              <Tab key={index} label={tab.label} disableTouchRipple />
            ))}
          </Tabs>
        </Grid2>
        <Grid2 size={12}>
          {tabs.map((tab, index) => (
            <Show.When key={index} isTrue={portfolioTabs === index}>
              <tab.component />
            </Show.When>
          ))}
        </Grid2>
      </Grid2>
    </>
  );
};

export default PortfolioSettingsEdit;
